import { Money } from '@dreryk/money-common-api';

import { getCustomFormattingContext, priceRangeFormatter } from '@dreryk/react-common';
import { TestableComponentProps, Text } from '@dreryk/react-components';

type PriceProps = {
   value: Money;
   min?: never;
   max?: never;
};

type PriceRangeProps = {
   min: Money;
   max: Money;
   value?: never;
};

type PriceTextProps = TestableComponentProps & (PriceProps | PriceRangeProps);

export const PriceText = (props: PriceTextProps): JSX.Element => {
   return (
      <Text testId={props.testId}>
         {priceRangeFormatter(
            {
               min: props.min?.asNumber() ?? props.value!.asNumber(),
               max: props.max?.asNumber() ?? props.value!.asNumber(),
            },
            getCustomFormattingContext({
               options: {
                  currency: 'PLN',
                  stripDecimalZeroes: true,
               },
            })
         )}
      </Text>
   );
};
